import React, { useEffect, useState } from 'react';
import { Box, Button, ClickAwayListener, Tooltip, Typography } from '@mui/material';
import { resolveCapabilityType } from '../../../constants/builderCategories';
import { libraryTooltipPaperSx } from '../LibraryTooltip';

const TYPE_DESCRIPTIONS = {
  prompt: 'Runs directly in chat with the information you provide. No connected tools are required.',
  skill: 'Uses connected tools or integrations to complete a workflow.',
  agent: 'Needs a supported agent runtime for autonomous or scheduled work.',
};

export default function CapabilityTypeInfoChip({ capabilityType, recommendedPlatformLabel, isMobile, iconOnlyOnMobile = true }) {
  const [open, setOpen] = useState(false);
  const type = resolveCapabilityType(capabilityType);
  const TypeIcon = type.Icon;

  useEffect(() => setOpen(false), [capabilityType]);

  const toggle = () => setOpen((value) => !value);

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box sx={{ display: 'inline-flex', flexShrink: 0 }}>
        <Tooltip
          placement={isMobile ? 'bottom' : 'bottom-end'}
          open={open}
          onOpen={() => { if (!isMobile) setOpen(true); }}
          onClose={() => setOpen(false)}
          disableTouchListener
          title={(
            <Box sx={{ width: 300, maxWidth: 'calc(100vw - 24px)', p: 1.5 }}>
              <Typography variant="subtitle2">
                Capability type: {type.label}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {TYPE_DESCRIPTIONS[type.value]}
              </Typography>
              {recommendedPlatformLabel && (
                <Typography variant="body2" color="text.secondary" sx={{ borderTop: 1, borderColor: 'divider', mt: 1, pt: 1 }}>
                  Recommended platform: {recommendedPlatformLabel}
                </Typography>
              )}
            </Box>
          )}
          componentsProps={{ tooltip: { sx: libraryTooltipPaperSx } }}
        >
          <Button
            size="small"
            aria-label={`${type.label} capability information`}
            aria-expanded={open}
            onClick={toggle}
            startIcon={<TypeIcon sx={{ fontSize: '16px !important' }} />}
            sx={{
              color: 'text.secondary',
              minWidth: { xs: iconOnlyOnMobile ? 32 : 0, sm: 0 },
              px: 0.5,
              py: 0.25,
              fontSize: '0.75rem',
              fontWeight: 500,
              textTransform: 'none',
              whiteSpace: 'nowrap',
              '& .MuiButton-startIcon': {
                mr: { xs: iconOnlyOnMobile ? 0 : 1, sm: 1 },
                ml: { xs: iconOnlyOnMobile ? 0 : -0.25, sm: -0.25 },
              },
            }}
          >
            <Box component="span" sx={{ display: { xs: iconOnlyOnMobile ? 'none' : 'inline', sm: 'inline' } }}>
              {type.label}
            </Box>
          </Button>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  );
}
